import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { FaChalkboardTeacher, FaGlasses,  FaArrowRight, FaHandsHelping, FaUsers, FaHeart } from 'react-icons/fa';
import Slider from "react-slick";

import { FaCheckCircle } from "react-icons/fa"; 

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './body.css';




import { FaTimes, FaMapMarkerAlt } from 'react-icons/fa';


function Body() {




  const stats = [
    { value: 34000, label: "Community Members Served", color: "blue" },
    { value: 300, label: "Volunteers", color: "teal" },
    { value: 304, label: "Programs Successfully Completed", color: "indigo" },
  ];

  const containerRef = useRef(null);
  const rafIdsRef = useRef([]); // store RAF ids to cancel on unmount
  const observerRef = useRef(null);
  const [counts, setCounts] = useState(() => stats.map(() => 0));
  const animatedRef = useRef(false); // ensure we animate once (or toggle if you want repeat)

  useEffect(() => {
    // Easing function for nicer animation
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const startCountUp = () => {
      if (animatedRef.current) return; // already animated
      animatedRef.current = true;

      const duration = 2000; // ms for each counter
      stats.forEach((stat, idx) => {
        const startTimeRef = { value: null };

        const step = (timestamp) => {
          if (!startTimeRef.value) startTimeRef.value = timestamp;
          const elapsed = timestamp - startTimeRef.value;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeOutCubic(progress);
          const current = Math.floor(eased * stat.value);

          // update only this index in state
          setCounts((prev) => {
            const next = [...prev];
            next[idx] = current;
            return next;
          });

          if (progress < 1) {
            const rafId = requestAnimationFrame(step);
            rafIdsRef.current[idx] = rafId;
          } else {
            // ensure final value is exact
            setCounts((prev) => {
              const next = [...prev];
              next[idx] = stat.value;
              return next;
            });
          }
        };

        // add a tiny stagger (optional) so numbers don't all start the exact same millisecond
        const staggerDelay = idx * 150;
        const handle = setTimeout(() => {
          rafIdsRef.current[idx] = requestAnimationFrame(step);
        }, staggerDelay);

        // store timeout id too so cleanup can clear it
        rafIdsRef.current[`timeout_${idx}`] = handle;
      });
    };

    // IntersectionObserver to start when section is visible
    observerRef.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          startCountUp();
          observerRef.current.disconnect();
        }
      },
      { threshold: 0.35 }
    );

    if (containerRef.current) observerRef.current.observe(containerRef.current);

    return () => {
      // cleanup RAFs and timeouts
      Object.values(rafIdsRef.current).forEach((id) => {
        if (typeof id === "number") cancelAnimationFrame(id);
        if (typeof id === "object" && id !== null && "then" in id) {
          /* noop - not used here */
        }
      });
      // clear any stored timeouts
      stats.forEach((_, idx) => {
        const t = rafIdsRef.current[`timeout_${idx}`];
        if (t) clearTimeout(t);
      });
      if (observerRef.current) observerRef.current.disconnect();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run once














  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };


  const phrases = ["Who We Are", "3 A's", "Awareness", "Available", "Affordable"];
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [typingSpeed, setTypingSpeed] = useState(1000); // Initial typing speed (1s)
  const [cursorBlink, setCursorBlink] = useState(true);
  
  useEffect(() => {
    // Cursor blink animation (unchanged)
    const cursorInterval = setInterval(() => {
      setCursorBlink(prev => !prev);
    }, 500);
    return () => clearInterval(cursorInterval);
  }, []);
  
  useEffect(() => {
    const handleTyping = () => {
      const currentPhrase = phrases[currentPhraseIndex];
      
      if (!isDeleting) {
        // TYPING PHASE (entire word in 1s)
        if (currentText.length < currentPhrase.length) {
          // Calculate per-character delay to finish in 1s
          const charDelay = 1000 / currentPhrase.length;
          setCurrentText(currentPhrase.substring(0, currentText.length + 1));
          setTypingSpeed(charDelay);
        } else {
          // PAUSE AFTER TYPING (0.5s)
          setTypingSpeed(500);
          setIsDeleting(true); // Start deleting after pause
        }
      } else {
        // DELETING PHASE (entire word in 0.5s)
        if (currentText.length > 0) {
          // Calculate per-character delay to finish in 0.5s
          const charDelay = 500 / currentText.length;
          setCurrentText(currentText.substring(0, currentText.length - 1));
          setTypingSpeed(charDelay);
        } else {
          // PAUSE AFTER DELETING (0.5s), then move to next word
          setTypingSpeed(500);
          setIsDeleting(false);
          setCurrentPhraseIndex((currentPhraseIndex + 1) % phrases.length);
        }
      }
    };
  
    const typingTimeout = setTimeout(handleTyping, typingSpeed);
    return () => clearTimeout(typingTimeout);
  }, [currentText, isDeleting, currentPhraseIndex]);







  

    const [isStoryOpen, setIsStoryOpen] = useState({
      story1: false,
      story2: false,
      story3: false
    });
  
    const toggleStory = (storyId) => {
      setIsStoryOpen((prevState) => ({
        ...prevState,
        [storyId]: !prevState[storyId]
      }));
    };
  


    const organizations = [
      { image: "/org1.png" },
      { image: "/org2.png" },
      { image: "/org3.png" },
      { image: "/org4.jpg" },
      { image: "/org5.png" },
      { image: "/org6.png" },
      { image: "/org7.png" },
      { image: "/org8.png" },
      { image: "/org9.png" },
      { image: "/org10.png" },
      { image: "/org11.jpg" },
      { image: "/org12.png" },
      { image: "/org13.jpg" },
      { image: "/org14.jpg" },
      { image: "/org15.jpeg" },
      { image: "/org16.png" },
  
    ];
    const [currentIndex, setCurrentIndex] = useState(0);
  
    const Carosettings = {
  
      infinite: true, // Infinite scroll
      speed: 500, // Transition speed
      slidesToShow: 5, // Show one image at a time
      slidesToScroll: 1, // Scroll one slide at a time
      autoplay: true, // Enable auto play
      autoplaySpeed: 2000, // Change image every 2 seconds
      pauseOnHover: true // Pause when hover
    };




  return (
    <div className="homepage">

     <section className="hero-banner">
      {/* Background image with overlay */}
      <div className="banner-background">
        <img src="/banner-cecc.png" alt="Eye care professionals helping community" className="banner-image" />
        <div className="banner-overlay"></div>
      </div>
      
      {/* Content container */}
      <div className="banner-content">
        <div className="hero-content">
          <h1 className='home-heading'>Community Eye Care</h1>
          <p>Providing affordable and accessible Eye care services to underprivileged communities in Sri Lanka</p>
          <div className="hero-buttons">
            <Link to="/screeningrequest">
              <button className="btn-secondary">
                Request Community Eye Care Programme <FaArrowRight />
              </button>
            </Link>
            <Link to="/supportmission">
              <button className="btn-secondary">Support Our Mission</button>
            </Link>
          </div>
        </div>
      </div>
     </section>



        {/*Who We Are Section*/}
        <div className='who-we-are-container'>
          <div className="animated-heading-container">
            <h2 className='home-heading typing-animation'>
              {currentText}
              <span className={`cursor ${cursorBlink ? 'blink' : ''}`}>|</span>
            </h2>
            <div className="animated-subtext"> 
              <p>
                At Community Eye Care, we believe that vision is a right not a privilege. As of more than 80% people of 
                Sri Lanka never had eye examination one time in their life. Resultantly blindness rate in Sri Lanka is 1.7% in above 40 
                years of age. More than 50% population cannot afford eye care goods and services. Most parts of Sri Lanka even 
                today People has to travel more than 50km to get eye care services.
                So we believe on mantra: 3A: increase Awareness on eye care, make eye care Available, provide eye care services affordable. 
                {/* <br /><br />
                Our volunteer initiatives provide opportunities for individuals to make a difference, 
                while our free eye check-up camps and provision of affordable spectacles ensure that 
                quality eye care is accessible to all. Through compassion, innovation, and community collaboration, 
                we’re opening eyes and doors to a brighter future. */}
              </p>
            </div>
          </div>
        </div>




{/* CSR Impact Bar */}
{/* <div className="csr-impact-bar">
  <div className="impact-item">
    <FaUsers className="impact-icon" />
    <div>
      <span className="impact-number">34,000+</span>
      <span className="impact-label">Community Members Served</span>
    </div>
  </div>
  <div className="impact-item">
    <FaHandsHelping className="impact-icon" /> {/* Changed from FaGlasses */}
    {/* <div>
      <span className="impact-number">300+</span>
      <span className="impact-label">Volunteers</span>
    </div>
  </div>
  <div className="impact-item">
    <FaCheckCircle className="impact-icon" /> {/* Changed from FaHeart */}
    {/* <div>
      <span className="impact-number">304+</span>
      <span className="impact-label">Programmes Successfully Completed</span>
    </div>
  </div>
</div>   */}









{/* Impact Stats Section */}
<section className="impact-stats" aria-labelledby="impact-stats-title">
  <div className="impact-stats__inner">
    <h2 id="impact-stats-title" className="impact-stats__heading">
      Our Impact
    </h2>

    <div className="impact-stats__grid" ref={containerRef}>

        {stats.map((stat, i) => (
          <article
            key={i}
            className={`impact-stats__card impact-stats__card--${stat.color}`}
            aria-labelledby={`impact-stat-title-${i}`}
          >
            <div className="impact-stats__circle" aria-hidden="true"></div>
            <div className="impact-stats__content">
              <h3
                className="impact-stats__number"
                id={`impact-stat-title-${i}`}
              >
                {counts[i].toLocaleString()}+
              </h3>
              <p className="impact-stats__description">{stat.label}</p>
            </div>
          </article>
        ))}
      </div>
      </div>
    </section>




      {/* CSR Programs Section */}
      <section className="csr-programs">
        <h2 className="section-title">Our Community Eye Care Programs</h2>
        <div className="programs-grid">

          <div className="program-card">
            <FaChalkboardTeacher  className="program-icon" />
            <h3>Teachers Training</h3>
            <p>In the Teachers Training program, we educate school teachers on conducting the 5-screen eye test and raise awareness to help identify vision problems in children at an early stage.</p>
            <Link to="/teachers-training">
              <button className='program-navigate-button'>Learn More</button>
            </Link>
          </div>


        <div className="program-card">
          <FaChalkboardTeacher className="program-icon" />
          <h3>Health Care Providers Training Program</h3>
            <p>
              Train eye care professionals, health care professionals (medical doctors, nurses, midwives, public health inspectors), and volunteers on eye care.
            </p>
            <Link to="/phi-training">
              <button className="program-navigate-button">Learn More</button>
            </Link>
          </div>

          <div className="program-card">
            <FaHandsHelping className="program-icon" />
            <h3>School Eye Health</h3>
            <p>e conduct eye check-ups and educational programs in schools to detect, prevent, and treat childhood vision problems early, promoting healthy eyesight for all children.</p>
            <Link to="/school-eye-health">
              <button className="program-navigate-button">Learn More</button>
            </Link>
          </div>

          <div className="program-card">
            <FaUsers className="program-icon" />
            <h3> Volunteer Program</h3>
            <p>
              The Volunteer Program, in collaboration with Leo Club members, supports community outreach by promoting eye health awareness and organizing eye camps across the island.
            </p>
            <Link to="/volunteer-program">
              <button className="program-navigate-button">Learn More</button>
            </Link>
          </div>

        </div>
      </section> 



      {/* Did You Know Section */}

<div className="did-you-know-section">
  <div className="did-you-know-image">
    <img src="/global.png" alt="Did you know post" />
  </div>

  <div className="did-you-know-content">
    <h1>Did You Know ?</h1>
    <p>
      Vision is more than just a sense; it's the foundation of productivity,
      education, and quality of life. The global cost of preventable vision
      loss is staggering, responsible for a yearly economic productivity loss
      of an estimated <strong>US$ 410 billion</strong> (The Lancet Global
      Health, 2021). This isn't just a number; it represents lost wages,
      missed educational opportunities, and a significant burden on families
      and communities.
      <br /><br />
      At Community Eye Care, we believe that providing accessible, high
      quality eye care is one of the most effective ways to strengthen our
      community. By investing in regular check-ups, early detection, and
      treatment, we're not only saving sight, we're unlocking human
      potential and ensuring a <strong>brighter, more productive future </strong>
       &nbsp;for everyone.
    </p>
  </div>
</div>






      {/* About CSR Section */}
      <section className="about-csr">
        <div className="about-content">
          <h2 className="about-section-title">What We Do ?</h2>
          <p>At Community Eye Care, we are dedicated to eliminating preventable blindness and vision impairment in Sri Lanka's most vulnerable communities</p>
          <ul className="csr-features">
            <li><span>✓</span> Train eye care personals, teachers, health care personals( medical doctors, nurses, midwife, public health inspectors), volunteers on eye care</li>
            <li><span>✓</span> Conduct eye care centers, eye care awareness, eye camps for adults and children ( reaching to unreached)</li>
            <li><span>✓</span> Providing affordable or free eye care services & goods</li>
            <li><span>✓</span> Uplifting life of visually impaired </li>
            <li><span>✓</span> Lobbying for developing policies and standards on  eye care</li>
          </ul>

          <Link to="/aboutus"><button className="btn-outline">Learn About Our Impact</button></Link>
        </div>
      </section>

      {/* Success Stories */}
      <section className="success-stories">
          <h2 className="section-title">Community Impact Stories</h2>
          <div className="stories-grid">
            <div className="story-card">
              <div className="story-image story-1"><img src="/eldery.jpg" className="story-image" /></div>
              <h3>Vision for Rural Elderly</h3>
              <p>How our mobile clinic restored vision for 200+ elderly in remote villages.</p>
              <button 
                className="btn-text" 
                onClick={() => toggleStory("story1")}
              >
                Read Story <FaArrowRight />
              </button>
              {isStoryOpen.story1 && (
                <div className="story-detail">
                  <p>We launched a mobile clinic that reached remote villages, providing eye exams, glasses, and consultations. The program helped restore vision for over 200 elderly people who had limited access to healthcare.</p>
                </div>
              )}
            </div>

            <div className="story-card">
              <div className="story-image story-2"><img src="/school1.jpg" className="story-image" /></div>
              <h3>School Screening Program</h3>
              <p>Detecting vision problems in 1,500+ school children across 3 districts.</p>
              <button 
                className="btn-text" 
                onClick={() => toggleStory("story2")}
              >
                Read Story <FaArrowRight />
              </button>
              {isStoryOpen.story2 && (
                <div className="story-detail">
                  <p>Through our school screening program, we identified vision problems in over 1,500 children across three districts. This initiative ensures that every child gets the eye care they need to succeed academically.</p>
                </div>
              )}
            </div>

            <div className="story-card">
              <div className="story-image story-3"><img src="/diabeties.jpg" className="story-image" /></div>
              <h3>Diabetes Eye Care</h3>
              <p>Preventing blindness through our diabetic retinopathy screening initiative.</p>
              <button 
                className="btn-text" 
                onClick={() => toggleStory("story3")}
              >
                Read Story <FaArrowRight />
              </button>
              {isStoryOpen.story3 && (
                <div className="story-detail">
                  <p>Our diabetes eye care program focuses on early detection of diabetic retinopathy, preventing vision loss and blindness. This initiative has screened hundreds of diabetic patients and helped prevent severe eye complications.</p>
                </div>
              )}
            </div>
          </div>
        </section>



        <div className="recycle-spectacles-section">
            <div className="recycle-container">
              <h2 className="section-title">
                <span className="title-icon">♻️</span>
                Give Your Old Glasses New Purpose
              </h2>
              
              <div className="recycle-content">
                <div className="recycle-hero">
                  <div className="hero-text">
                    <h3>We're Transforming Eye Care Through Recycling</h3>
                    <p className="lead">
                      Every pair of recycled spectacles helps someone in need see clearly while reducing environmental waste. 
                      Join our mission to create sustainable Eye Care for all.
                    </p>
                  </div>

                  <div className="hero-image">
                    <img src="/recyclepng.png" alt="Recycle Glasses" />
                  </div>

                </div>



                    <div className="recycle-benefits">
                      <h4>The Impact of Your Donation:</h4>
                      <div className="benefits-grid">
                        <div className="benefit-card">
                          <div className="benefit-icon">👓</div>
                          <h5>Vision for Those in Need</h5>
                          <p>Your recycled glasses provide affordable vision correction to underserved communities.</p>
                        </div>
                        
                        <div className="benefit-card">
                          <div className="benefit-icon">🌎</div>
                          <h5>Environmental Protection</h5>
                          <p>We keep thousands of frames and lenses out of landfills each year.</p>
                        </div>
                        
                        <div className="benefit-card">
                          <div className="benefit-icon">🔄</div>
                          <h5>Circular Economy</h5>
                          <p>Materials are repurposed or properly recycled through our zero-waste process.</p>
                        </div>
                        
                        <div className="benefit-card">
                          <div className="benefit-icon">❤️</div>
                          <h5>Community Support</h5>
                          <p>Proceeds fund free eye exams and vision programs for disabled individuals.</p>
                        </div>
                        
                        <div className="benefit-card">
                          <div className="benefit-icon">👨‍👩‍👧‍👦</div>
                          <h5>Empowering Families</h5>
                          <p>Clear vision helps parents work and children learn, breaking cycles of poverty.</p>
                        </div>
                        
                        <div className="benefit-card">
                          <div className="benefit-icon">👁️</div>
                          <h5>Prevents Eye Strain & Damage</h5>
                          <p>Proper prescription glasses reduce long-term vision problems caused by uncorrected eyesight.</p>
                        </div>
                      </div>
                    </div>




                <div className="recycle-process">
                  <h4>Our Simple Recycling Process:</h4>
                  <div className="process-steps">
                    <div className="process-step">
                      <div className="step-number">1</div>
                      <div className="step-content">
                        <h5>Collection</h5>
                        <p>Drop off at any of our locations.</p>
                      </div>
                    </div>
                    
                    <div className="process-step">
                      <div className="step-number">2</div>
                      <div className="step-content">
                        <h5>Assessment</h5>
                        <p>Our opticians evaluate each pair for reuse potential.</p>
                      </div>
                    </div>
                    
                    <div className="process-step">
                      <div className="step-number">3</div>
                      <div className="step-content">
                        <h5>Sanitization</h5>
                        <p>Professional cleaning and sterilization using medical-grade solutions.</p>
                      </div>
                    </div>
                    
                    <div className="process-step">
                      <div className="step-number">4</div>
                      <div className="step-content">
                        <h5>Redistribution</h5>
                        <p>Glasses are matched with recipients or responsibly recycled.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="recycle-cta">
                  <div className="cta-content">
                    <h4>Ready to Make an Impact?</h4>
                    <p>
                      Your unused glasses can change lives. Find a drop-off location near you or schedule a pickup.
                    </p>
                    <div className="cta-buttons">

                       <button  className="cta-button primary" onClick={togglePopup}>
        Find a Location
      </button>
      
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-container">
            <button className="close-button" onClick={togglePopup}>
              <FaTimes />
            </button>
            <div className="info-card">
              <div className="icon-box">
                <FaMapMarkerAlt className="info-icon" />
              </div>
              <h3>Our Centers</h3>
              <div className="location">
                <h4>Colombo 08 - Center</h4>
                <p>No: 932, Maradana Road, Colombo 08</p>
              </div>
              <div className="location">
                <h4>Moratuwa Center</h4>
                <p>No: 23, Uswatta Circular Rd, Moratuwa</p>
              </div>
            </div>
          </div>
        </div>
      )}




                  
                    </div>
                  </div>
                  <div className="cta-stats">
                    <div className="stat-item">
                      <div className="stat-number-c">15,000+</div>
                      <div className="stat-label-c">Pairs Recycled</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number-c">25</div>
                      <div className="stat-label-c">Districts Served</div>
                    </div>
                    <div className="stat-item">
                      <div className="stat-number-c">100%</div>
                      <div className="stat-label-c">Zero Waste</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>




     



        <div className="brand-carousel-container">
          <h3 className='brand-carousel-heading'>Organisations with whom we collaborate</h3>
            <Slider {...Carosettings}>
              {organizations.map((org, index) => (
                <div key={index} className="brand-slide">
                  <img src={org.image} alt={`Org ${index}`} className="brand-image" />
                  <h3>{org.name}</h3>
                </div>
              ))}
            </Slider>
          </div>

    </div>
  );
}

export default Body;